import {getOutOfStockProductsInListQuery} from '@data/queries/stock/getOutOfStockProductsInList'
import isServerSide from '@helpers/misc/isServerSide'
import {useApolloQuery} from '@packages/apollo-hooks'
import uniq from 'lodash/uniq'

export default function useSetOutOfStockProducts({websiteId, categories, storeId, deliverAt}): {
  outOfStockIds: string[]
} {
  const productsIds = []

  const cats = categories ? categories.items : []
  for (const category of cats) {
    for (const product of category.products) {
      productsIds.push(product._id)
    }
  }

  const {outOfStockIds} = useApolloQuery({
    query: getOutOfStockProductsInListQuery,
    variables: {websiteId, productsIds: uniq(productsIds), storeId, deliverAt},
    partial: true,
    omit: productsIds.length === 0 || !storeId || isServerSide()
  })

  if (!outOfStockIds || !outOfStockIds.length) return {outOfStockIds: []}

  return {outOfStockIds}
}
